/* ============================================================
   NIGHTLEGS — CART DRAWER
   AJAX cart interactions: open/close, add, update, remove
   ============================================================ */

(function() {
  'use strict';

  var CartDrawer = {
    drawer:    null,
    overlay:   null,
    body:      null,
    countEl:   null,
    isOpen:    false,
    threshold: 35, // free shipping threshold in dollars
    bump:      null, // order-bump config (set in the Cart Drawer section settings)

    init: function() {
      this.drawer  = document.getElementById('cart-drawer');
      this.overlay = document.getElementById('site-overlay');
      this.body    = document.getElementById('cart-drawer-body');
      this.countEl = document.getElementById('cart-count');

      var bumpEl = document.getElementById('cart-bump-config');
      if (bumpEl) {
        try { this.bump = JSON.parse(bumpEl.textContent); } catch (e) { this.bump = null; }
      }

      if (!this.drawer) return;

      this._bindEvents();
    },

    _bindEvents: function() {
      var self = this;

      // Global open event
      document.addEventListener('cart:open', function() { self.open(); });
      document.addEventListener('cart:close', function() { self.close(); });

      // Close button
      var closeBtn = document.getElementById('cart-drawer-close');
      if (closeBtn) closeBtn.addEventListener('click', function() { self.close(); });

      // Overlay click
      if (this.overlay) {
        this.overlay.addEventListener('click', function() { self.close(); });
      }

      // Escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && self.isOpen) self.close();
      });

      // Add to cart buttons (delegated)
      document.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-add-to-cart]');
        if (!btn) return;
        e.preventDefault();
        var variantId = btn.dataset.variantId;
        var qty       = parseInt(btn.dataset.qty || '1', 10);
        if (variantId) self.addItem(variantId, qty, btn);
      });

      // Qty change (delegated, inside drawer)
      document.addEventListener('click', function(e) {
        var btn = e.target.closest('.cart-item__qty-btn');
        if (!btn) return;
        var line  = parseInt(btn.dataset.line, 10);
        var delta = parseInt(btn.dataset.delta, 10);
        if (!isNaN(line) && !isNaN(delta)) self.changeQty(line, delta);
      });

      // Remove item (delegated)
      document.addEventListener('click', function(e) {
        var btn = e.target.closest('.cart-item__remove');
        if (!btn) return;
        var line = parseInt(btn.dataset.line, 10);
        if (!isNaN(line)) self.removeItem(line);
      });

      // Checkout button pixel event
      var checkoutBtn = document.getElementById('cart-checkout-btn');
      if (checkoutBtn) {
        checkoutBtn.addEventListener('click', function() {
          if (typeof fbq !== 'undefined') {
            fbq('track', 'InitiateCheckout');
          }
        });
      }
    },

    open: function() {
      if (!this.drawer) return;
      this.isOpen = true;
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      if (this.overlay) this.overlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      this.refresh();

      // Hide sticky ATC if visible
      var stickyBar = document.getElementById('sticky-atc');
      if (stickyBar) stickyBar.style.opacity = '0';
    },

    close: function() {
      if (!this.drawer) return;
      this.isOpen = false;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      if (this.overlay) this.overlay.classList.remove('is-active');
      document.body.style.overflow = '';

      // Restore sticky ATC
      var stickyBar = document.getElementById('sticky-atc');
      if (stickyBar) stickyBar.style.opacity = '';
    },

    refresh: function() {
      var self = this;
      this._fetch('/cart.js', {}, 'GET', function(cart) {
        self._render(cart);
        self._updateCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      });
    },

    addItem: function(variantId, qty, btn) {
      var self = this;

      if (btn) {
        btn.disabled = true;
        var originalText = btn.innerHTML;
        btn.innerHTML = '<span class="spinner"></span>';
      }

      this._fetch('/cart/add.js', {
        items: [{ id: parseInt(variantId, 10), quantity: qty }]
      }, 'POST', function(result) {
        if (btn) {
          btn.innerHTML = originalText;
          btn.disabled = false;
        }

        if (result.status && result.status !== 200) {
          alert(result.description || 'Could not add to cart.');
          return;
        }

        if (typeof fbq !== 'undefined') {
          fbq('track', 'AddToCart', {
            value: result.items ? result.items[0].final_price / 100 : 0,
            currency: 'USD',
            content_ids: [variantId],
            content_type: 'product'
          });
        }

        self.open();
      });
    },

    changeQty: function(line, delta) {
      var self = this;
      var itemEl = document.querySelector('[data-line="' + line + '"]');
      var currentQty = itemEl ? parseInt(itemEl.dataset.qty || '1', 10) : 1;
      var newQty = Math.max(0, currentQty + delta);

      this._fetch('/cart/change.js', { line: line, quantity: newQty }, 'POST', function(cart) {
        self._render(cart);
        self._updateCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      });
    },

    removeItem: function(line) {
      this.changeQty(line, -9999);
    },

    _render: function(cart) {
      if (!this.body) return;

      if (cart.item_count === 0) {
        this.body.innerHTML = this._emptyState();
        return;
      }

      var threshold = parseFloat(document.body.dataset.freeShippingThreshold || '0');
      var subtotal  = cart.total_price / 100;
      var remaining = Math.max(0, threshold - subtotal);
      var progress  = Math.min(100, (subtotal / threshold) * 100);

      var html = '';

      // Shipping progress bar
      html += '<div class="cart-shipping-bar">';
      if (remaining > 0) {
        html += '<p class="cart-shipping-bar__text">Add <strong>$' + remaining.toFixed(2) + '</strong> more for <strong>FREE shipping!</strong></p>';
      } else {
        html += '<p class="cart-shipping-bar__text cart-shipping-bar__text--success">🎉 You\'ve unlocked <strong>FREE shipping!</strong></p>';
      }
      html += '<div class="cart-shipping-bar__track"><div class="cart-shipping-bar__fill" style="width:' + progress + '%"></div></div>';
      html += '</div>';

      // Items
      html += '<div class="cart-items">';
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        html += this._renderItem(item, i + 1);
      }
      html += '</div>';

      // Upsell — only makes sense with a single unit. Once there are 2+ in the cart,
      // "grab 2 / add another" is redundant, so hide it. Never offer it on the bump product.
      var bumpVariantId = this.bump ? this.bump.variantId : null;
      if (cart.item_count === 1 && cart.items[0] && cart.items[0].variant_id !== bumpVariantId) {
        html += '<div class="cart-upsell">';
        html += '<p class="cart-upsell__text">👥 Most people grab 2 — one for the nightstand, one for travel</p>';
        html += '<button class="cart-upsell__btn btn btn-ghost btn-sm" data-add-to-cart data-variant-id="' + cart.items[0].variant_id + '" data-qty="1">Add another</button>';
        html += '</div>';
      }

      // Order bump (door/safety alarm) — only when configured and not already in the cart.
      if (this.bump && bumpVariantId) {
        var hasBump = false;
        for (var b = 0; b < cart.items.length; b++) {
          if (cart.items[b].variant_id === bumpVariantId) { hasBump = true; break; }
        }
        if (!hasBump) {
          html += '<div class="cart-bump">';
          if (this.bump.image) {
            html += '<div class="cart-bump__img"><img src="' + this.bump.image + '" alt="' + this._escape(this.bump.title) + '" width="56" height="56" loading="lazy"></div>';
          }
          html += '<div class="cart-bump__info">';
          html += '<p class="cart-bump__text">' + this._escape(this.bump.text || this.bump.title) + '</p>';
          html += '<p class="cart-bump__price">$' + (this.bump.price / 100).toFixed(2) + '</p>';
          html += '</div>';
          html += '<button class="cart-bump__btn btn btn-primary btn-sm" data-add-to-cart data-variant-id="' + bumpVariantId + '" data-qty="1">' + this._escape(this.bump.cta || 'Add') + '</button>';
          html += '</div>';
        }
      }

      // Footer
      html += '<div class="cart-drawer__footer">';
      html += '<div class="cart-totals">';
      html += '<div class="cart-totals__row"><span>Subtotal</span><span class="cart-totals__price">$' + subtotal.toFixed(2) + '</span></div>';
      if (remaining <= 0) {
        html += '<div class="cart-totals__row cart-totals__row--shipping"><span>Shipping</span><span class="cart-totals__free">FREE</span></div>';
      } else {
        html += '<div class="cart-totals__row"><span>Shipping</span><span>Calculated at checkout</span></div>';
      }
      html += '</div>';
      html += '<a href="/checkout" class="btn btn-primary btn-full btn-lg" id="cart-checkout-btn" aria-label="Proceed to checkout">Checkout · $' + subtotal.toFixed(2) + '</a>';
      html += '<p class="cart-drawer__secure">🔒 Secure, encrypted checkout</p>';
      html += '</div>';

      this.body.innerHTML = html;
    },

    _renderItem: function(item, line) {
      var img = item.image ? ('<img src="' + item.image + '" alt="' + this._escape(item.title) + '" width="64" height="64" loading="lazy">') : '';
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? ('<p class="cart-item__variant">' + this._escape(item.variant_title) + '</p>') : '';

      return (
        '<div class="cart-item" data-line="' + line + '" data-qty="' + item.quantity + '">' +
          '<div class="cart-item__img">' + img + '</div>' +
          '<div class="cart-item__details">' +
            '<p class="cart-item__title">' + this._escape(item.title) + '</p>' +
            variantTitle +
            '<p class="cart-item__price">$' + (item.final_line_price / 100).toFixed(2) + '</p>' +
          '</div>' +
          '<div class="cart-item__controls">' +
            '<div class="qty-selector">' +
              '<button class="qty-selector__btn cart-item__qty-btn" data-line="' + line + '" data-delta="-1" aria-label="Decrease quantity" type="button">−</button>' +
              '<span class="qty-selector__input">' + item.quantity + '</span>' +
              '<button class="qty-selector__btn cart-item__qty-btn" data-line="' + line + '" data-delta="1" aria-label="Increase quantity" type="button">+</button>' +
            '</div>' +
            '<button class="cart-item__remove" data-line="' + line + '" aria-label="Remove ' + this._escape(item.title) + ' from cart" type="button">' +
              '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>'
      );
    },

    _emptyState: function() {
      return (
        '<div class="cart-empty">' +
          '<div class="cart-empty__icon">🛒</div>' +
          '<p class="cart-empty__title">Your cart is empty</p>' +
          '<p class="cart-empty__sub">Firm, targeted pressure — made for bed.</p>' +
          '<a href="' + (window.nightlegs && window.nightlegs.productUrl || '/collections/all') + '" class="btn btn-primary">Shop NightLegs</a>' +
        '</div>'
      );
    },

    _updateCount: function(count) {
      if (!this.countEl) return;
      this.countEl.textContent = count;
      if (count === 0) {
        this.countEl.classList.add('is-empty');
      } else {
        this.countEl.classList.remove('is-empty');
      }
    },

    _fetch: function(url, data, method, callback) {
      // Prefix with the locale-aware root so Markets locales ('/en-ca/') keep working.
      var root = (window.nightlegs && window.nightlegs.rootUrl) || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (url.charAt(0) === '/') url = root + url.slice(1);

      var options = {
        method: method,
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
      };

      if (method !== 'GET' && data) {
        options.body = JSON.stringify(data);
      }

      fetch(url, options)
        .then(function(res) { return res.json(); })
        .then(function(json) { callback(json); })
        .catch(function(err) { console.error('Cart error:', err); });
    },

    _escape: function(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
  };

  document.addEventListener('DOMContentLoaded', function() {
    CartDrawer.init();
  });

  window.NightLegsCart = CartDrawer;
})();
